"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RoseTreeIterators_1 = require("./RoseTreeIterators");
/**
 * This class represents a generic rose tree implementation of a tree data structure.
 */
var RoseTree = /** @class */ (function () {
    // TODO make defensive copy of node and children
    function RoseTree(node, children) {
        this.node = node;
        this.children = children;
    }
    /**
     * Smart constructor for creating a rose tree leaf.
     *
     * @param node - The node at the root of the leaf.
     */
    RoseTree.leaf = function (node) {
        return new RoseTree(node, []);
    };
    Object.defineProperty(RoseTree.prototype, "isLeaf", {
        /**
         * Checks if this tree is a leaf.
         */
        get: function () {
            return !this.children || this.children.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoseTree.prototype, "height", {
        /**
         * Computes the height of this tree.
         */
        get: function () {
            return this.isLeaf ? 0 : 1 + this.children.reduce(function (h, child) { return Math.max(h, child.height); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoseTree.prototype, "size", {
        /**
         * Returns the number of nodes in this tree.
         */
        get: function () {
            return this.fold(function (sum) { return sum + 1; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Checks if this tree is equal to a given tree. Two trees are equal if they have the same shape and each of the corresponding nodes are
     * equal. Nodes are compared using strict equality.
     *
     * @param otherTree - The other tree to compare to this tree.
     */
    RoseTree.prototype.equals = function (_a) {
        var node = _a.node, children = _a.children;
        if (this.node === node && this.children.length === children.length) {
            return this.children.every(function (child, i) { return child.equals(children[i]); });
        }
        else {
            return false;
        }
    };
    /**
     * Map operation for tree.
     *
     * @param f - The function to map over this tree.
     */
    RoseTree.prototype.map = function (f) {
        return new RoseTree(f(this.node), this.children.map(function (child) { return child.map(f); }));
    };
    /**
     * Maps the tree to a new tree. Passes in each node's depth to the iteratee function.
     *
     * @param f - The function for mapping over this tree.
     * @param depth - The depth of the root node. Defaults to 0.
     */
    RoseTree.prototype.mapWithDepth = function (f, depth) {
        if (depth === void 0) { depth = 0; }
        return new RoseTree(f(this.node, depth), this.children.map(function (child) { return child.mapWithDepth(f, depth + 1); }));
    };
    /**
     * Runs a function on every node in a tree. NOTE unlike `forEach` for arrays, this does not pass the node's index into the iteratee
     * function.
     *
     * @param tree - The tree to iterate over.
     * @param f - The function to be executed on each node.
     * @param ip - An iterator provider that defines the order of traversal. Uses pre-order traversal by default.
     */
    RoseTree.prototype.forEach = function (f, ip) {
        if (ip === void 0) { ip = RoseTreeIterators_1.preOrderTraversal; }
        var iterator = ip(this);
        var ir = iterator.next();
        while (!ir.done) {
            f(ir.value);
            ir = iterator.next();
        }
    };
    /**
     * Fold operation, i.e., reduce, for tree.
     *
     * @param f - The function to fold over this tree.
     * @param acc - The initial accumulator value.
     */
    RoseTree.prototype.fold = function (f, acc) {
        return this.children.reduce(function (s, child) { return child.fold(f, s); }, f(acc, this.node));
    };
    /**
     * Checks if some node in this tree satisfies the given predicate.
     *
     * @param p - The predicate.
     */
    RoseTree.prototype.some = function (p) {
        return this.fold(function (q, t) { return q || p(t); }, false);
    };
    /**
     * Checks if all node in this tree satisfies the given predicate.
     *
     * @param p - The predicate.
     */
    RoseTree.prototype.all = function (p) {
        return this.fold(function (q, t) { return q && p(t); }, true);
    };
    return RoseTree;
}());
exports.RoseTree = RoseTree;
//# sourceMappingURL=RoseTree.js.map